import type { FC } from 'react';

import {
  VerificationAccountLevels,
  VerificationCard,
} from '@/components/VerificationWidget/parts';

interface VerificationWidgetProps {
  isVerified?: boolean;
  title: string;
  description: string;
  action?: {
    title: string;
    callback: () => void;
  };
}
export const VerificationWidget: FC<VerificationWidgetProps> = ({
  isVerified,
  title,
  description,
  action,
}) => {
  return (
    <div className="flex flex-col gap-8">
      {!isVerified && (
        <VerificationCard
          title={title}
          description={description}
          action={action}
        />
      )}
      <VerificationAccountLevels
        isVerified={isVerified}
        className="hidden px-6 lg:block"
      />
    </div>
  );
};
